module.exports = ".form-group {\n    position: relative;\n}\n\n.main-container{\n    margin-left: 20px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/appversion/appversion.component.css
// module id = ./src/app/components/appversion/appversion.component.css
// module chunks = main